const context = (context) => () => context;
export default context;
